<template>
  <div>
    <h2>Taxas de Operação</h2>

    <v-data-table
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="perPage"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="searchFilter.query"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            v-if="false"
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogForm" max-width="940px">
            <template
              v-slot:activator="{ on, attrs }"
              v-if="permissions['create_fee']"
            >
              <v-btn
                outlined
                color="#0dc4b8"
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                v-if="false"
              >
                Nova Taxa
              </v-btn>
            </template>
            <FeeForm
              v-if="dialogForm"
              :selectedIndex="selectedIndex"
              :selectedData="selectedItem"
              :selectedActive="active"
              v-on:onClose="closeFormModal"
              v-on:onSubmit="
                closeFormModal();
                loadData();
              "
            />
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline center"
                >Deseja realmente excluir {{ selectedItem.code }} -
                {{ selectedItem.name }} ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0dc4b8" text @click="closeDeleteModal"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="#0dc4b8"
                  text
                  @click="deleteItemConfirm"
                  :disabled="
                    isLoading ||
                    ['Administrador', 'Cliente'].includes(selectedItem.name)
                  "
                  :loading="isLoading"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template
        v-slot:item.actions="{ item }"
        v-if="permissions['edit_fee']"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :loading="isLoading">
              <v-icon
                dense
                @click="openEditItemModal(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="permissions['delete_fee']"
          >
            <v-icon
              dense
              @click="openDeleteItemModal(item)"
              v-bind="attrs"
              v-on="on"
              v-if="false"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Excluir</span>
        </v-tooltip>
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total > 0"
            >Exibindo {{ from }} - {{ to }} de {{ total }}
          </span>
        </div>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="totalPages"></v-pagination>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapMutations } from "vuex";
import FeeForm from "./_form.vue";
import Api from "../../services/api.service";

export default {
  name: "Fee",
  components: {
    FeeForm,
  },
  data: () => ({
    data: [],
    dialogForm: false,
    dialogDelete: false,
    dialogGenerate: false,
    isLoadingGenerate: true,
    from: 0,
    headers: [
      { text: "Código", value: "code" },
      { text: "Nome da Taxa", value: "name"},
      { text: "Tipo", value: "type"},
      { text: "Valor Fixo", value: "fixed_value"},
      { text: "Fator", value: "factor_value"},
    ],
    isLoading: true,
    page: 1,
    perPage: 10,
    searchFilter: {
      query: null,
    },
    selectedIndex: -1,
    selectedItem: {},
    idEdit: 0,
    sortBy: "fee.code",
    to: 0,
    total: 0,
    totalPages: 0,
    value: 0,
    query: false,
    show: true,
    interval: 0,
    active : {},
   
  }),
  computed: {
    ...mapGetters(["permissions"]),
  },
  mounted() {
    if (this.permissions["edit_fee"] || this.permissions["delete_fee"]) {
      this.headers.push({ text: "Ações", value: "actions", sortable: false });
    }

    this.loadData();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),


    clearForm() {
      this.selectedIndex = -1;
      this.selectedItem = {};
    },

    closeFormModal() {
      this.dialogForm = false;
      this.loadData();
      this.$nextTick(() => {
        this.clearForm();
      });
    },

    closeDeleteModal() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.clearForm();
      });
    },

    closeGenerateModal() {
      this.dialogGenerate = false;
    },

    deleteItemConfirm() {
      this.isLoading = true;
      Api.delete(`fee/${this.selectedItem.code}`)
        .then(() => {
          this.loadData();
          this.showSnackbar({
            text: "Taxa de Operação deletada com sucesso!",
            color: "success",
          });
          this.closeDeleteModal();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.showSnackbar({
            ext: "Ops! Ocorreu um erro, tente novamente.",
            color: "error",
          });
        });
    },

    loadData() {
      this.isLoading = true;

      Api.get("fee")
        .then((res) => {
          var arrayActives = [];
          res.data[0].map((item) => {
            arrayActives.push({
              code: item.id,
              name: item.name,
              type: item.type,
              fixed_value: item.fixed_value,
              factor_value: item.factor_value,
            });
          });


          this.data = arrayActives;

          this.isLoading = false;
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops! Houve um erro ao carregar os dados, tente novamente.",
            color: "error",
          });
          this.isLoading = false;
        });
    },

    openDeleteItemModal(item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    openEditItemModal(item) {
      this.isLoading = true;

      Api.get(`fee/${item.code}`)
        .then((res) => {
          this.selectedItem = res.data.fee[0];
          this.selectedIndex = item.code;
          
          this.isLoading = false;

          setTimeout(() => {
            this.dialogForm = true;
          }, 11);
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops! Houve um erro ao carregar os dados, tente novamente.",
            color: "error",
          });
          this.isLoading = false;
        });
    },
  },
};
</script>
